import type { RouteRecordRaw } from 'vue-router'

export const HELLO_WORLD = {
  ABOUT_US: 'hello_about_us',
  APP: 'hello_app',
  APP_NOT_LOCALIZED: 'hello_app_not_localized',
  '500_ERROR': 'hello_500',
}

const routes: RouteRecordRaw[] = [
  {
    component: () => import('../about-us/AboutUs.vue'),
    name: HELLO_WORLD.ABOUT_US,
    path: '/:locale/hello-about-us',
  },
  {
    component: () => import('./HelloWorld.vue'),
    name: HELLO_WORLD.APP,
    path: '/:locale/hello-front-office-app',
  },
  {
    component: () => import('./Hello500.vue'),
    name: HELLO_WORLD['500_ERROR'],
    path: '/:locale/hello-front-office-500',
  },
  {
    path: '/hello-front-office-app-not-localized',
    name: HELLO_WORLD.APP_NOT_LOCALIZED,
    component: () => import('./HelloWorld.vue'),
  },
]

export default routes
